module.exports = __webpack_public_path__ + "img/boissons.698a1705.png";